// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"e_qe","pageSubTitle":"e_re"};